import C from  '../constants/alert';

export function initAlert(alertData) {
    return function (dispatch) {
        dispatch({
            type: C.SET_ALERT,
            payload: alertData
        });
        dispatch({
            type: C.ALERT_ACTIVE,
            payload: true
        });
    }
}

export function toggleAlert(alertActive) {
    return function (dispatch) {
        dispatch({
            type: C.ALERT_ACTIVE,
            payload: alertActive
        });
    }
}



// WEBPACK FOOTER //
// ./actions/alert.js